export default "__VITE_ASSET__nyGWQYxV__"